var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashCanicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2018_11585",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2018_11585",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB70lEQVR4nO2WO24VQRBFCwJ+W4C9kYHUxUNygtSVzApAMh+5i4TcCzEiMruAiI8sSAd1SGbg8W55fI50wzdPc+bqdpsBAAAAAADA5Xi4vLvjMV60GJ89cv3DfJq/nc+45N9dX1rky78Q/Ht6HqvfozjrjdbH138WHfltPsu2wqMl73kfb+aL7UHOWjHzw7fI10dHz+/KRHuMoRbhB8sYEsnLstxskT/1AvIw6fljvjOiY6Oir9t0tJ4npmIeEN7Hqz3dFNai+TKvnNLDEAAAAODwFLiGrf8jVg21EEe0XhaNDr1IpiNqxKqhFuKI1sui0aEXyXREjVg11EIc0XpZNDr0IpmOqBGrhlqII1ovi0aHXiTTETVi1VALcUTrZdHo0ItkOqJGrBpqIY5ovSwaHXqRTEfUiFVDLcQRrZdFo0MvkumIGrFqqIU4ovWyaHToRTIdUSNWDbUQR7ReFo0OvUimI2rEqqEW4ojWy6LRoRfJdESNWDXUQhzRelk0OvQimY6oEauGWogjWi+LRode5NWbjp4Xaim+57Se360areeH7Yke760aLfLp5kRHPrFq7HbHt1vkR7Uc31f6OF+W01tWkd2ztw82IbuP88dxct8qM5vtfezmvl2pA7LnRYs8m3NRtskAAAAAAAAAAFaDX73XQ2gdse91AAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCanicon);
export default __webpack_public_path__ + "static/media/TrashCanicon.32b860a2e7a039db5af8cfe8570df9e0.svg";
export { ForwardRef as ReactComponent };